import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import TagAdd from "./component";

const TagAddContainer = () => {
  const navigate = useNavigate();
  const { makeApiRequest } = useApiRequest();

  const [tokenNumber, setTokenNumber] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [taguid, setTaguid] = useState("");
  const [loader, setLoader] = useState(false);
  const [tagActive, setTagActive] = useState(false);
  const [askLink, setAskLink] = useState(false);
  const [secretkey, setSecretkey] = useState("");

  useEffect(() => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    if (!UserJWTAuth) navigate("/login");
  }, []);

  // 🧩 Common Header
  const getHeaders = (extraHeaders = {}) => ({
    Authorization: `Bearer ${localStorage.getItem("UserJWTAuth")}`,
    "x-app-platform": "web",
    "x-app-version": "v1.0.1",
    "x-device-id": localStorage.getItem("uuid"),
    ...extraHeaders,
  });

  // ✳️ Handlers
  const handleChangeOtp = (otp) => setSecretkey(otp);
  const handleChangeRfIDToken = (e) => setTokenNumber(e.target.value);
  const handleChangeSecretkey = (key) => setSecretkey(key);

  // 🧠 Search Token API
  const handleResponseSearchToken = (res) => {
    const response = res?.data?.response;
    setTaguid(response?.uid);
    setTagActive(response?.active);
    localStorage.setItem("TagUUID", response?.uid);
    setLoader(false);

    if (response?.active) {
      setPageCount((prev) => prev + 1);
    } else {
      toast.error("TAG NOT ACTIVE", { position: "top-right", autoClose: 1000 });
    }
  };

  const handleErrorSearchToken = (error) => {
    setLoader(false);
    if ([401, 403].includes(error?.response?.status)) {
      navigate("/login");
    } else {
      toast.error(error?.response?.data?.statusMessage, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  const SearchToken = () => {
    setLoader(true);
    makeApiRequest({
      url: `/auth/tag/search?qrData=${tokenNumber}`,
      method: "GET",
      headers: getHeaders(),
      handleSuccess: handleResponseSearchToken,
      handleError: (err) => handleErrorSearchToken(err),
    });
  };

  // 🧠 Secret Key Link API
  const handleResponseSecretKeyLink = (res) => {
    setLoader(false);
    setPageCount((prev) => prev + 1);
    navigate("/taglist");
  };

  const handleErrorSecretKeyLink = (err) => {
    setLoader(false);
    navigate("/taglist");
    toast.error(err?.response?.data?.statusMessage || "Error linking tag", {
      position: "top-right",
      autoClose: 1000,
    });
  };

  const LinkTagFun = () => {
    setLoader(true);
    makeApiRequest({
      url: `/auth/tag/${taguid}/link`,
      method: "POST",
      headers: getHeaders({
        "x-tag-secret": secretkey,
      }),
      data: { request: { replaceCurrentAccount: true } },
      handleSuccess: handleResponseSecretKeyLink,
      handleError: (err) => handleErrorSecretKeyLink(err),
    });
  };

  // 🧠 Secret Key Active API
  const handleResponseSecretKeyActive = (res) => {
    setLoader(false);
    setPageCount((prev) => prev + 1);
    LinkTagFun();
    setTimeout(() => navigate("/taglist"), 1000);
  };

  const handleErrorSecretKeyActive = (err) => {
    setLoader(false);
    navigate("/taglist");
    toast.error(err?.response?.data?.statusMessage || "Activation failed", {
      position: "top-right",
      autoClose: 1000,
    });
  };

  const SubmitSecretKeyActive = () => {
    setLoader(true);
    makeApiRequest({
      url: `/auth/tag/${taguid}/active`,
      method: "POST",
      headers: getHeaders({
        "x-tag-secret": secretkey,
      }),
      data: { replaceCurrentAccount: false },
      handleSuccess: handleResponseSecretKeyActive,
      handleError: (err) => handleErrorSecretKeyActive(err),
    });
  };

  return (
    <TagAdd
      handleChangeRfIDToken={handleChangeRfIDToken}
      SearchToken={SearchToken}
      pageCount={pageCount}
      handleChangeSecretkey={handleChangeSecretkey}
      loader={loader}
      askLink={askLink}
      setTokenNumber={setTokenNumber}
      tokenNumber={tokenNumber}
      handleChangeOtp={handleChangeOtp}
      secretkey={secretkey}
      LinkTagFun={LinkTagFun}
      SubmitSecretKeyActive={SubmitSecretKeyActive}
    />
  );
};

export default TagAddContainer;
